export default __webpack_public_path__ + "static/media/DOC_symbolDark.9a626107.svg";